import { DownOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, Dropdown, Space } from 'antd';
import getFromConfig from 'constants/config';
import { useTheme } from 'emotion-theming';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const AccountInfo = styled.div`
  background-color: ${props => props.theme.colors.black2};
  padding: 5px 0;

  p {
    font-size: 10px;
    line-height: 1.3em;
    color: white;
    padding: 0;
    margin: 0;
    &:hover {
      background-color: ${props => props.theme.colors.primary} !important;
    }
    a {
      padding: 10px;
      color: white;
      &:visited,
      &:focus {
        color: white !important;
      }
    }
  }
`;

const UserMenu = ({ accountOrg, account }) => {
  const { logout, user, isLoading } = useAuth0();
  const org = accountOrg?.accountOrg;
  const loggedInUser = account?.account;
  const history = useHistory();
  const location = useLocation();
  const isSamePath = location.pathname?.includes('/discover/network/');
  const { colors } = useTheme();
  const isAdmin = loggedInUser?.isAdmin;

  if (isLoading || !org || !loggedInUser) {
    return null;
  }

  const nameString = user.name || loggedInUser.name || '';
  const nameSplits = nameString ? nameString.trim().split(' ') : [];

  let abbv = '';
  if (nameSplits.length > 0) {
    abbv += nameSplits[0][0].toUpperCase();
  }
  if (nameSplits.length > 1) {
    abbv += nameSplits.at(-1)[0].toUpperCase();
  }

  const getLegacyMapUrl = () => {
    let url = getFromConfig('REACT_APP_RISKBOX_BASE_URL');
    if (getFromConfig('REACT_APP_NEW_LOGIN_EXPERIENCE')) {
      url += 'authorize';
    }
    return url;
  };

  const doLogout = () => {
    let returnTo = `${getFromConfig('REACT_APP_RISKBOX_BASE_URL')}logout-all/`;
    if (getFromConfig('REACT_APP_NEW_LOGIN_EXPERIENCE')) {
      returnTo = `${getFromConfig('REACT_APP_RISKBOX_BASE_URL')}logout`;
    }
    logout({ returnTo });
  };

  const menuList = [
    {
      key: '0',
      label: (
        <AccountInfo>
          <p>{user.email || loggedInUser.email}</p>
          <p>{org.name}</p>
        </AccountInfo>
      ),
      className: 'info',
    },
    {
      key: '1',
      label: <a href={getLegacyMapUrl()}>Everstream Map</a>,
      className: 'link',
    },
    ...(org?.prefs?.discover?.network_viz !== false &&
    (org?.prefs?.discover?.enabled || org?.prefs?.materials?.enabled) &&
    !isSamePath
      ? [
          {
            key: '2',
            label: <a href="/discover/network/">Network</a>,
            className: 'link',
          },
        ]
      : []),
    {
      key: '3',
      label: <a href="/users/profile/">Profile</a>,
      className: 'link',
    },
    ...(isAdmin
      ? [
          {
            key: '4',
            label: 'Account Admin',
            className: 'link',
            onClick: () => history.push('/admin/'),
          },
        ]
      : []),
    {
      type: 'divider',
    },
    {
      key: '5',
      label: 'Logout',
      className: 'link',
      onClick: () => doLogout(),
    },
  ];

  return (
    <>
      <Global
        styles={css`
          .user-dropdown.ant-dropdown .ant-dropdown-menu-item {
            background-color: #141414;
            font-size: 12px;
          }

          .user-dropdown.ant-dropdown .ant-dropdown-menu-root,
          .user-dropdown.ant-dropdown .ant-dropdown-menu-item:hover {
            background-color: #141414 !important;
          }

          .user-dropdown.ant-dropdown .ant-dropdown-menu-item.link {
            color: #ffffff;
          }

          .user-dropdown.ant-dropdown .ant-dropdown-menu-item.link:hover {
            color: #ffffff;
            background-color: #2d8fa5;
          }

          .user-dropdown.ant-dropdown .ant-dropdown-menu-item.info {
            cursor: auto;
            background-color: #212121;
          }

          .user-dropdown.ant-dropdown .ant-dropdown-menu-item a {
            color: #ffffff !important;
          }

          .user-dropdown.ant-dropdown .ant-dropdown-menu-item-divider {
            background-color: #212121 !important;
          }
        `}
      />
      <Dropdown
        overlayClassName="user-dropdown"
        menu={{
          items: menuList,
          style: {
            backgroundColor: colors.black1,
            borderWidth: '1px',
            borderColor: colors.black2,
            borderStyle: 'solid',
          },
        }}
        placement="bottomLeft"
        trigger={['click']}
      >
        <a href="/" onClick={e => e.preventDefault()}>
          <Space size="small" style={{ color: 'white', fontSize: '12px' }}>
            <Avatar style={{ backgroundColor: colors.primary }}>{abbv}</Avatar>
            {nameString}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </>
  );
};

function mapStateToProps({ accountOrg, account }) {
  return {
    accountOrg,
    account,
  };
}

export default connect(mapStateToProps)(UserMenu);
